"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IExtraParams = void 0;
const openapi_1 = require("../../../openapi");
class IExtraParams {
    method;
    page;
    skubana_sales_channel;
    price_field;
    skubana_currency;
    skubana_ship_service;
    skubana_hold_future_orders;
    skubana_hold_days;
    skubana_custom_1;
    skubana_custom_1_custom;
    skubana_custom_2;
    skubana_custom_2_custom;
    skubana_custom_3;
    skubana_custom_3_custom;
    custom_listing_name;
    custom_listing_value;
    skubana_overwrite_address;
    skubana_first_name;
    skubana_last_name;
    skubana_address;
    skubana_city;
    skubana_state;
    skubana_zip;
    skubana_country;
    skubana_overwrite_phone;
    skubana_phone;
    skubana_edi;
    skubana_invoice_num;
    app_owner;
    api_owner_email;
    owner_setup_key;
    first_setup_complete;
    wms_first_setup_complete;
    product_filter_level;
    last_retrieveInventoryLevels;
    download_product_update;
    auto_product_import;
    prevent_duplicate_names;
    '3PL_deferNotification';
    '3PL_ponum_custom';
    '3PL_ponum';
    '3PL_ship_date_field';
    '3PL_ship_cancel_date';
    '3PL_department_number_custom';
    '3PL_department_number';
    '3PL_contact_code_custom';
    '3PL_contact_code';
    '3PL_send_currency';
    '3PL_send_price_info';
    '3PL_require_name';
    '3PL_custom_door_number';
    'map_ship_address_2';
    '3PL_ship_retailer_id';
    '3PL_ship_retailer_id_custom';
    '3PL_ship_retailer';
    '3PL_sold_retailer_id';
    '3PL_sold_retailer_id_custom';
    '3PL_sold_retailer';
    '3PL_require_signature';
    '3plc_notes_field';
    notes_field_value;
    notes_hard_coded;
    shipping_notes_value;
    shipping_notes_hard_coded;
    shipping_notes_field;
    '3pl_qualifier_field';
    '3PL_item_qualifier';
    item_notes_field;
    '3PL_billing_code';
    '3PL_ship_account_zip';
    '3PL_ship_account';
    inv_unit_identifier;
    stop_403_alerts;
    '3PL_send_cancel';
    capture_payments;
    fulfillment_service;
    location_name;
    order_prefix;
    download_product_price;
    download_draft_orders;
    download_full_order;
    pos_customer_address_replacement;
    skip_draft_order_source;
    location_map_6827;
    location_map_6875;
    location_map_6883;
    location_map_6962;
    location_map_6963;
    shopify_turn_webhooks_on;
    shopify_enable_orders_create_webhook;
    shopify_enable_orders_cancelled_webhook;
    shopify_enable_fulfillments_create_webhook;
    shopify_enable_refunds_create_webhook;
    shopify_enable_products_delete_webhook;
    shopify_enable_products_update_webhook;
    shopify_enable_products_create_webhook;
    shopify_enable_orders_updated_webhook;
    shopify_enable_orders_fulfilled_webhook;
    location_map_6969;
    location_map_6980;
    filter_fulfillment_location;
    default_unmapped_ship_code;
    reject_unmapped_ship_codes;
    reject_cass_error;
    enable_order_prefix;
    validate_address_intl;
    validate_address;
    earliest_order_date;
    sync_warehouse;
    inventory_sync_alias;
    sync_product_price;
    order_status;
    financial_status;
    fulfillment_status;
    ignore_nonshippable;
    use_fulfillable_quantity;
    ignore_fulfilled_shipments;
    order_id_field;
    ship_method_field;
    order_tags;
    archive_orders;
    order_delay;
    prime_carrier;
    prime_ship_code;
    load_gift_message_from;
    load_metafields;
    load_order_source;
    load_payment_data;
    load_cancelled_orders;
    send_cancel;
    inventory_sync_location;
    ship_signature;
    ship_insurance;
    filter_tags_list;
    filter_tags;
    customer_filter_tags_list;
    customer_tags_filter_method;
    customer_filter_tags;
    source_filter_custom;
    source_filter;
    confirmation_email;
    update_post_type;
    update_post_ship;
    update_post_field;
    fulfillment_service_location;
    blank_sku_action;
    minimum_inventory_level;
    translate_item_code;
    item_field;
    prime_ship_code_prefix;
    prime_writeback;
    load_prime_orders;
    refund_delay;
    load_shipped_orders;
    amazon_fulfill_latency;
    send_amazon_latency;
}
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "method", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "page", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "skubana_sales_channel", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "price_field", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "skubana_currency", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "skubana_ship_service", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "skubana_hold_future_orders", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "skubana_hold_days", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "skubana_custom_1", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "skubana_custom_1_custom", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "skubana_custom_2", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "skubana_custom_2_custom", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "skubana_custom_3", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "skubana_custom_3_custom", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "custom_listing_name", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "custom_listing_value", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "skubana_overwrite_address", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "skubana_first_name", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "skubana_last_name", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "skubana_address", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "skubana_city", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "skubana_state", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "skubana_zip", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "skubana_country", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "skubana_overwrite_phone", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "skubana_phone", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "skubana_edi", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "skubana_invoice_num", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "app_owner", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "api_owner_email", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "owner_setup_key", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "first_setup_complete", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "wms_first_setup_complete", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "product_filter_level", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "last_retrieveInventoryLevels", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "download_product_update", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "auto_product_import", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "prevent_duplicate_names", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "3PL_deferNotification", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "3PL_ponum_custom", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "3PL_ponum", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "3PL_ship_date_field", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "3PL_ship_cancel_date", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "3PL_department_number_custom", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "3PL_department_number", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "3PL_contact_code_custom", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "3PL_contact_code", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "3PL_send_currency", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "3PL_send_price_info", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "3PL_require_name", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "3PL_custom_door_number", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "map_ship_address_2", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "3PL_ship_retailer_id", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "3PL_ship_retailer_id_custom", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "3PL_ship_retailer", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "3PL_sold_retailer_id", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "3PL_sold_retailer_id_custom", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "3PL_sold_retailer", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "3PL_require_signature", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "3plc_notes_field", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "notes_field_value", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "notes_hard_coded", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "shipping_notes_value", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "shipping_notes_hard_coded", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "shipping_notes_field", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "3pl_qualifier_field", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "3PL_item_qualifier", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "item_notes_field", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "3PL_billing_code", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "3PL_ship_account_zip", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "3PL_ship_account", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "inv_unit_identifier", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "stop_403_alerts", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "3PL_send_cancel", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "capture_payments", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "fulfillment_service", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "location_name", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "order_prefix", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "download_product_price", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "download_draft_orders", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "download_full_order", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "pos_customer_address_replacement", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "skip_draft_order_source", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "location_map_6827", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "location_map_6875", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "location_map_6883", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "location_map_6962", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "location_map_6963", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "shopify_turn_webhooks_on", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "shopify_enable_orders_create_webhook", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "shopify_enable_orders_cancelled_webhook", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "shopify_enable_fulfillments_create_webhook", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "shopify_enable_refunds_create_webhook", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "shopify_enable_products_delete_webhook", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "shopify_enable_products_update_webhook", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "shopify_enable_products_create_webhook", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "shopify_enable_orders_updated_webhook", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "shopify_enable_orders_fulfilled_webhook", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "location_map_6969", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "location_map_6980", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "filter_fulfillment_location", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "default_unmapped_ship_code", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "reject_unmapped_ship_codes", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "reject_cass_error", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "enable_order_prefix", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "validate_address_intl", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "validate_address", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "earliest_order_date", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "sync_warehouse", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "inventory_sync_alias", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "sync_product_price", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "order_status", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "financial_status", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "fulfillment_status", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "ignore_nonshippable", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "use_fulfillable_quantity", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "ignore_fulfilled_shipments", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "order_id_field", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "ship_method_field", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "order_tags", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "archive_orders", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "order_delay", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "prime_carrier", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "prime_ship_code", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "load_gift_message_from", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "load_metafields", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "load_order_source", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "load_payment_data", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "load_cancelled_orders", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "send_cancel", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "inventory_sync_location", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "ship_signature", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "ship_insurance", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "filter_tags_list", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "filter_tags", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "customer_filter_tags_list", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "customer_tags_filter_method", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "customer_filter_tags", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "source_filter_custom", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "source_filter", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "confirmation_email", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "update_post_type", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "update_post_ship", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "update_post_field", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "fulfillment_service_location", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "blank_sku_action", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "minimum_inventory_level", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "translate_item_code", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "item_field", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "prime_ship_code_prefix", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "prime_writeback", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "load_prime_orders", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "refund_delay", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "load_shipped_orders", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IExtraParams.prototype, "amazon_fulfill_latency", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['N', 'Y'] })
], IExtraParams.prototype, "send_amazon_latency", void 0);
exports.IExtraParams = IExtraParams;
